import logger from '@rmp-shared/helpers/logger/logger';

export default class LoggerManager {
  constructor() {
    window.Reedsy = window.Reedsy || {};
    window.Reedsy.logger = logger;
  }
}
